import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
const networkIdTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Network ID',
  key: 'networkIdTemplate',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['networkId', 'description', 'ownIPAddress'],
          ['$empty', '$empty', '$empty'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        initial: '',
        hide: 'true',
      },
      networkId: {
        label: 'Network ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 16,
            },
          ],
        },
      },
      description: {
        label: 'Description',
        type: 'text',
        initial: '',
      },
      ownIPAddress: {
        label: 'Local IP Address',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 42,
            },
            {
              type: 'IPAddress',
              errorMessage: 'Must be a valid IP Address. Please re-enter.',
              invalidIPs: [
                '255.255.255.255',
              ],
            },
          ],
        },
      },
    },
  },
  portRange: {
    metadata: {
      layout: {
        rows: [
          ['startPortNumber', 'portNumberRange', 'nodeName'],
        ],
      },
    },
    fields: {
      startPortNumber: {
        label: 'Starting Port Number',
        type: 'text',
        initial: '',
      },
      portNumberRange: {
        label: 'Max. Number of Ports',
        type: 'text',
        initial: '0',
        validation: {
          required: true,
        },
      },
      nodeName: {
        label: 'Node Name',
        type: 'select',
        initial: '',
        options: [
          {
            label: 'Select a Node',
            value: ''
          }
        ]
      }
    },
  },
};

export default networkIdTemplate;
